"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Slider = _interopRequireDefault(require("./Slider.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var SlideItem = (0, _component.default)(function () {
  return import("../SlideItem");
});
var Slider = function Slider(_ref) {
  var absoluteMediaURLs = _ref.absoluteMediaURLs,
    active = _ref.active,
    animationRef = _ref.animationRef,
    hideTexts = _ref.hideTexts,
    items = _ref.items,
    mediaFormats = _ref.mediaFormats,
    playAnimation = _ref.playAnimation,
    showBlurredBackground = _ref.showBlurredBackground,
    stopAnimation = _ref.stopAnimation,
    textStyles = _ref.textStyles,
    webpFallback = _ref.webpFallback;
  var css = (0, _Slider.default)();
  var isActive = (0, _react.useCallback)(function (index) {
    return active === index;
  }, [active]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.slider, "mco-animation-01__slider")
  }, items.map(function (item, index) {
    var _ref2 = item || {},
      bitmaps = _ref2.bitmaps,
      duration = _ref2.duration,
      id = _ref2.id,
      media = _ref2.media,
      texts = _ref2.texts;
    return /*#__PURE__*/_react.default.createElement(SlideItem, {
      absoluteMediaURLs: absoluteMediaURLs,
      animationRef: animationRef,
      bitmaps: bitmaps,
      counter: index,
      duration: duration,
      hideTexts: hideTexts,
      itemsLength: items === null || items === void 0 ? void 0 : items.length,
      key: id,
      media: media,
      mediaFormats: mediaFormats,
      playAnimation: playAnimation,
      show: isActive(index),
      showBlurredBackground: showBlurredBackground,
      stopAnimation: stopAnimation,
      texts: texts,
      textStyles: textStyles,
      webpFallback: webpFallback
    });
  }));
};
var _default = Slider;
exports.default = _default;